<i18n
  src="@/locales/views/organization/production/query_by_provider/show_exported_batch.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_exp_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_provider_details')"
    :params="{
      organization_id: organization_id,
      agro_exporter_process_id: agro_exporter_process_id,
      provider_id: provider_id,
      provider_type: provider_type
    }"
  />
  <bread-crumbs :labels="[module_name, agro_exporter_process.name, producer]" />
  <template v-if="load_data_general">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
            <em>
              <a class="link" :href="exported_batch.tx_url" target="_blank">
                {{ exported_batch.tx_hash }}
              </a>
            </em>
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-slate-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
              <div class="sm:col-span-1 grid gap-y-6 gap-x-4">
                <div>
                  <dt class="label-data">
                    {{ $t("model.exported_batch.batch_code") }}
                  </dt>
                  <dd class="content-data">
                    {{ exported_batch.batch_code }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.registered_at") }}
                  </dt>
                  <dd class="content-data">
                    {{
                      dateFormatter(exported_batch.harvested_batches[0]?.registered_at)
                    }}
                  </dd>
                </div>
                <div
                  v-if="
                    provider_type == 'organization' ||
                    exported_batch.organization
                  "
                >
                  <dt class="label-data">
                    {{ $t("model.exported_batch.organization") }}
                  </dt>
                  <dd class="content-data">
                    {{ exported_batch.organization?.name }}
                  </dd>
                </div>
                <div
                  v-if="provider_type == 'producer' || exported_batch.producer"
                >
                  <dt class="label-data">
                    {{ $t("model.exported_batch.producer") }}
                  </dt>
                  <dd class="content-data">
                    {{ producer_label }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.exported_batch.crop_field") }}
                  </dt>
                  <dd class="content-data">
                    {{ exported_batch.crop_field?.name }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.total_weight") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_batch?.total_weight }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.discarded_weight") }}
                  </dt>
                  <dd class="content-data ">
                    {{ harvested_batch?.discarded_weight }}
                  </dd>
                </div>

                <div>
                  <dt class="label-data">
                    {{ $t("labels.percents") }}
                  </dt>
                  <dd class="content-data mr-48 py-4">
                    <percent-bar
                      :ok_percent="harvested_batch.ok_percent"
                      :err_percent="harvested_batch.discarded_percent"
                      min_width="full"
                    />
                  </dd>
                </div>
              </div>
              <div
                class="sm:col-span-1"
                v-if="crop_field.latitude_dd && crop_field.longitude_dd"
              >
                <google-map
                  :lat="crop_field.latitude_dd"
                  :lng="crop_field.longitude_dd"
                  :title="crop_field.name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- pkg -->
    <div class="mt-8 flex flex-row justify-between">
      <h1 class="page-title">
        <i class="fa-solid fa-box"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_packages") }}
      </h1>
    </div>
    <div class="mt-6 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_brand") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_size") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.quantity") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="pkg in exported_batch.packages"
                  :key="pkg.id"
                >
                  <td class="table-cell">
                    {{ pkg.exporter_process_brand.agro_exporter_brand.name }}
                  </td>
                  <td class="table-cell">
                    {{
                      pkg.exporter_process_crop_size.agro_exporter_crop_size
                        .crop_size.name
                    }}
                  </td>
                  <td class="table-cell">
                    {{ pkg.quantity }}
                    {{
                      $t("model.package.exporter_process_crop_package_value", {
                        name: pkg.exporter_process_crop_package.name,
                        weight: pkg.exporter_process_crop_package.net_weight
                      })
                    }}
                    <em
                      ><a class="link" :href="pkg.tx_url" target="_blank">{{
                        pkg.tx_hash
                      }}</a></em
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_provider/show_exported_batch.js";
import GoogleMap from "@/components/views/layout/GoogleMap.vue";
import PercentBar from "@/components/views/layout/PercentBar.vue";

export default {
  name: "OrgProcessPackingShowHarvestedBatch",
  components: {
    GoogleMap,
    PercentBar
  },
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      exported_batch: {}
    };
  },
  props: {
    organization_id: { required: true },
    agro_exporter_process_id: { required: true },
    exported_batch_id: { required: true },
    provider_id: { required: true },
    provider_type: { required: true }
  },
  computed: {
    producer_label: function () {
      if (this.exported_batch.producer?.producer_code) {
        return `${this.exported_batch.producer.producer_code} - ${this.exported_batch.producer?.fullname}`;
      } else {
        return this.exported_batch.producer?.fullname;
      }
    },
    producer: function () {
      if (this.provider_type == "producer")
        return this.exported_batch.producer?.fullname;

      if (this.provider_type == "organization")
        return this.exported_batch.organization?.name;

      return "";
    },
    crop_field: function () {
      return {
        latitude_dd: Number(this.exported_batch.crop_field?.latitude_dd),
        longitude_dd: Number(this.exported_batch.crop_field?.longitude_dd),
        name: this.exported_batch.crop_field?.name
      };
    },
    harvested_batch: function () {
      const harvested_batches = this.exported_batch.harvested_batches;
      let harvested_batch = {
        total_weight: harvested_batches.reduce(
          (acc, harvested_batch) => acc + Number(harvested_batch.total_weight),
          0
        ),
        discarded_weight: harvested_batches.reduce(
          (acc, harvested_batch) =>
            acc + Number(harvested_batch.discarded_weight),
          0
        ),
        harvested_packages: harvested_batches
          .map(harvested_batch => harvested_batch.harvested_packages)
          .flat()
          .reduce((acc, harvested_package) => {
            const key = harvested_package.crop_har_package.id;
            if (!acc[key]) {
              acc[key] = {
                crop_har_package: harvested_package.crop_har_package.name,
                number: 0
              };
            }
            acc[key].number += harvested_package.number;
            return acc;
          }, {})
      };
      harvested_batch["ok_percent"] =
        harvested_batch.total_weight > 0
          ? ((harvested_batch.total_weight - harvested_batch.discarded_weight) /
              harvested_batch.total_weight) *
            100
          : 0;
      harvested_batch["discarded_percent"] = harvested_batch.total_weight
        ? (harvested_batch.discarded_weight / harvested_batch.total_weight) *
          100
        : 0;

      return harvested_batch;
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchExportedBatch();
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchExportedBatch: async function () {
      let response = await Requester.fetchExportedBatch(
        this.organization_id,
        this.exported_batch_id
      );
      this.exported_batch = response.data;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
